import _get from 'lodash/get'

import * as schemaUtils from '@flows/configs/shared/schemaUtils'
import type { StepConfigParams } from '@flows/configs/types'
import type { AnyStepConfiguration, FlowValues } from '@flows/core/types/stepTypes'
import { BaseSchema_DogLiabilityV1GetsafeDe } from '@flows/insurance/schemas'

const dog_previously_owned = (params: StepConfigParams) =>
  ({
    schema: schemaUtils.generateZodObjectFromPaths({
      [params.helperFunctions.getParamPath('previous_insurance_in_last_5y')]:
        BaseSchema_DogLiabilityV1GetsafeDe.shape.previous_insurance_in_last_5y,
    }),
    stepContent: [
      {
        type: 'title',
        text: {
          type: 'translatableText',
          translationKey: 'sharedFlows_dogLiabilityNxt:steps.previously_owned.title',
        },
      },
      {
        type: 'yesNo',
        shouldTrackValues: true,
        name: params.helperFunctions.getParamPath('previous_insurance_in_last_5y'),
      },
    ],
    subFlow: params.subFlow,
    onSubmit: {
      type: 'simpleHook',
      inputs: [params.helperFunctions.getParamPath('previous_insurance_in_last_5y')],
      outputs: [
        params.helperFunctions.getParamPath('number_of_claims_in_last_5y'),
        params.helperFunctions.getParamPath('previous_insurance_in_last_5y'),
      ],
      callback: (formValues: FlowValues) => {
        const prevInsurance = _get(
          formValues,
          params.helperFunctions.getParamPath('previous_insurance_in_last_5y')
        )

        if (prevInsurance === false) {
          return {
            formValues: {
              [params.helperFunctions.getParamPath('number_of_claims_in_last_5y')]: 0,
              [params.helperFunctions.getParamPath('cancelled_by_previous_insurer')]: false,
            },
          }
        }
      },
    },
    nextStepConfig: {
      valuePath: params.helperFunctions.getParamPath('previous_insurance_in_last_5y'),
      valueToStepName: {
        true: 'dog_damages',
        false: 'dog_sos_help',
      },
    },
  }) as const satisfies AnyStepConfiguration

export default dog_previously_owned
